export const APP_AUDIO_OUTPUT_EVENT = 'museflow-app-audio-output';

export const DEFAULT_APP_AUDIO_SUPPRESSION_MS = 120;

export interface AppAudioOutputDetail {
  delayMs?: number;
  durationMs?: number;
  reason?: 'metronome' | 'prompt' | 'playback';
}

export const notifyAppAudioOutput = ({
  delayMs = 0,
  durationMs = DEFAULT_APP_AUDIO_SUPPRESSION_MS,
  reason = 'playback',
}: AppAudioOutputDetail = {}) => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent<AppAudioOutputDetail>(APP_AUDIO_OUTPUT_EVENT, {
      detail: {
        delayMs: Math.max(0, delayMs),
        durationMs: Math.max(0, durationMs),
        reason,
      },
    }),
  );
};
